import React, { useState, Fragment, Component } from 'react';
import { motion } from 'framer-motion';
import { TartaEmblem } from './TartaEmblem';
import { AmbientLight } from './AmbientLight';
import { useLanguage } from '../context/LanguageContext';
export function Waitlist() {
  const {
    t
  } = useLanguage();
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    flavor: ''
  });
  const [errors, setErrors] = useState<{
    name?: string;
    email?: string;
  }>({});
  const [submitted, setSubmitted] = useState(false);
  const validate = () => {
    const e: typeof errors = {};
    if (!form.name.trim()) e.name = t.waitlist.required;
    if (!form.email.trim()) e.email = t.waitlist.required;else if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = t.waitlist.invalidEmail;
    setErrors(e);
    return Object.keys(e).length === 0;
  };
  const onSubmit = (e: any) => {
    e.preventDefault();
    if (!validate()) return;
    // Option A — open a pre-filled email to TARTA with the sign-up details.
    // (Interim solution; to be replaced by a form service in Option B.)
    const to = 'tarta@tartahtx.com';
    const subject = `New flavor & market updates sign-up — ${form.name.trim()}`;
    const bodyLines = ['New sign-up for TARTA flavor & market updates:', '', `Name: ${form.name.trim()}`, `Email: ${form.email.trim()}`, `Phone: ${form.phone.trim() || '—'}`, `City / Area: ${form.city.trim() || '—'}`, `Favorite flavor: ${form.flavor || '—'}`];
    const mailto = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(bodyLines.join('\n'))}`;
    window.location.href = mailto;
    setSubmitted(true);
  };
  return <section id="waitlist" className="bg-texture-dark text-cream py-32 lg:py-48 relative overflow-hidden" data-id="element-396" data-mp="349dl4y6tuah0">
      <AmbientLight variant="center" data-id="element-397" data-mp="16i0xe1jcervp" />
      <div className="relative z-10 max-w-[820px] mx-auto px-8 lg:px-14" data-id="element-398" data-mp="12gz3m0873814">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-399" data-mp="12eur4tw8d0p8">
          <div className="absolute -inset-1 border border-cream/15 pointer-events-none" aria-hidden data-id="element-400" data-mp="2qy8pd6ry8ir3" />
          <div className="border border-cream/25 px-8 py-16 sm:px-16 sm:py-20 lg:px-24 lg:py-24 text-center bg-chocolate/40 backdrop-blur-sm" data-id="element-401" data-mp="3jpin9geg4dtq">
            <div className="flex flex-col items-center gap-8 mb-12" data-id="element-402" data-mp="35p7wedd4yz8k">
              <TartaEmblem size={104} variant="dark" withTagline circleLight className="ring-1 ring-cream/20" data-id="element-403" data-mp="3anj7erf63fsd" />
              <span className="font-serif italic text-caramel text-[13px] tracking-[0.05em]" data-id="element-404" data-mp="1za6y410n24yt">
                {t.waitlist.invitation}
              </span>
            </div>

            <h2 className="font-serif text-cream font-light leading-[0.95] tracking-[-0.025em]" style={{
            fontSize: 'clamp(44px, 7vw, 96px)'
          }} data-id="element-405" data-mp="1mrcozv551tvz">
              {t.waitlist.title1}
              <br data-id="element-406" data-mp="1vsawwoip6lju" />
              <span className="italic font-extralight" data-id="element-407" data-mp="181wzeihcfuhv">
                {t.waitlist.title2}
              </span>
            </h2>

            <p className="mt-10 text-cream/55 leading-[1.85] text-[15px] max-w-md mx-auto" data-id="element-408" data-mp="133lp66n4zhz4">
              {t.waitlist.copy}
            </p>

            <ul className="mt-12 flex flex-col sm:flex-row sm:flex-wrap items-center justify-center gap-y-4 sm:gap-x-6 lg:gap-x-10 text-[10px] tracking-[0.3em] uppercase text-cream/55" data-id="element-409" data-mp="1ht1dlfz73bbn">
              {t.waitlist.benefits.map((label, idx) => <Fragment key={label} data-id="element-410" data-mp="kcukhie3gfr2" data-mpi={idx}>
                  <li className="flex items-baseline gap-3 whitespace-nowrap" data-id="element-411" data-mp="kbt91ct61r8t">
                    <span className="font-serif italic text-caramel normal-case tracking-[0.05em] text-[13px]" data-id="element-412" data-mp="3jrellzf9mpz6">
                      {['i.', 'ii.', 'iii.'][idx]}
                    </span>
                    <span data-id="element-413" data-mp="3sqrv2s3e3ejw">{label}</span>
                  </li>
                  {idx < t.waitlist.benefits.length - 1 && <span className="hidden sm:inline w-1 h-1 rounded-full bg-caramel/50" aria-hidden data-id="element-414" data-mp="1d5le2o8l7in" />}
                </Fragment>)}
            </ul>

            {!submitted ? <form onSubmit={onSubmit} noValidate className="mt-16 max-w-md mx-auto text-left space-y-8" data-id="element-415" data-mp="g9d7x9n4al13">
                <Field label={t.waitlist.labelName} value={form.name} onChange={v => setForm({
              ...form,
              name: v
            })} error={errors.name} placeholder={t.waitlist.placeholderName} data-id="element-416" data-mp="2i0zsotgf1jp4" />
                <Field label={t.waitlist.labelEmail} type="email" value={form.email} onChange={v => setForm({
              ...form,
              email: v
            })} error={errors.email} placeholder={t.waitlist.placeholderEmail} data-id="element-417" data-mp="24t8xq5ujzt4j" />
                <Field label={t.waitlist.labelPhone} optionalLabel={t.waitlist.optional} optional type="tel" value={form.phone} onChange={v => setForm({
              ...form,
              phone: v
            })} placeholder={t.waitlist.placeholderPhone} data-id="element-418" data-mp="2ogqdsoi3su45" />
                <Field label={t.waitlist.labelCity} value={form.city} onChange={v => setForm({
              ...form,
              city: v
            })} placeholder={t.waitlist.placeholderCity} data-id="element-419" data-mp="19icihik1fk5p" />

                {/* Favorite Flavor dropdown */}
                <div data-id="element-420" data-mp="vke3caxw7jp5">
                  <label className="block text-[10px] tracking-[0.3em] uppercase text-cream/50 mb-3" data-id="element-421" data-mp="vkwa41i6lgbb">
                    {t.waitlist.labelFlavor}
                  </label>
                  <div className="relative" data-id="element-422" data-mp="gtnenbrll0q9">
                    <select value={form.flavor} onChange={e => setForm({
                  ...form,
                  flavor: e.target.value
                })} className="w-full bg-transparent border-b border-cream/20 focus:border-caramel outline-none py-3 text-cream transition-colors duration-500 font-serif text-lg appearance-none cursor-pointer [&>option]:bg-chocolate [&>option]:text-cream" data-id="element-423" data-mp="lvmeibo4pfig">
                      <option value="" disabled data-id="element-424" data-mp="3uclhlm7pnjx8">
                        {t.waitlist.flavorPlaceholder}
                      </option>
                      {t.waitlist.flavorOptions.map(opt => <option key={opt} value={opt} data-id="element-425" data-mp="77vu7dn271h5">
                          {opt}
                        </option>)}
                    </select>
                    <span className="pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 text-caramel" aria-hidden data-id="element-426" data-mp="lyv02gwifbx1">
                      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" data-id="element-427" data-mp="uxq7fwbais1x">
                        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.2" data-id="element-428" data-mp="pzoln3mhcemr" />
                      </svg>
                    </span>
                  </div>
                </div>

                <div className="pt-8 text-center" data-id="element-429" data-mp="26csqujxe98qy">
                  <button type="submit" className="group inline-flex items-center gap-5 text-cream" data-id="element-430" data-mp="2balsr0rnzglf">
                    <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-431" data-mp="1elwa3887qjye" />
                    <span className="font-serif italic text-[15px] tracking-[0.05em]" data-id="element-432" data-mp="1ijker2zpjr3h">
                      {t.waitlist.submit}
                    </span>
                    <span className="w-12 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-20 transition-all duration-500" data-id="element-433" data-mp="1schxna8m3i2m" />
                  </button>
                  <p className="mt-8 text-[10px] tracking-[0.2em] uppercase text-cream/35 leading-[1.8] max-w-sm mx-auto" data-id="element-434" data-mp="zv5l07y09yyz">
                    {t.waitlist.footnote}
                  </p>
                </div>
              </form> : <motion.div initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} className="mt-16" data-id="element-435" data-mp="ndco49v9cgfg">
                <p className="text-[10px] tracking-[0.5em] uppercase text-caramel mb-8" data-id="element-436" data-mp="4ltmo7gvtafj">
                  {t.waitlist.confirmed}
                </p>
                <h3 className="font-serif text-4xl sm:text-5xl leading-[1.05] font-light" data-id="element-437" data-mp="3vswe900mtiqa">
                  {t.waitlist.welcome}
                  <br data-id="element-438" data-mp="3mryi13wfqfi9" />
                  <span className="italic font-extralight" data-id="element-439" data-mp="3msgf22qx8xr8">
                    {form.name.split(' ')[0]}.
                  </span>
                </h3>
                <p className="mt-8 text-cream/60 leading-[1.85] text-[15px] max-w-md mx-auto" data-id="element-440" data-mp="3huyccu3hzero">
                  {t.waitlist.thanks}
                </p>
              </motion.div>}
          </div>
        </motion.div>
      </div>
    </section>;
}
function Field({
  label,
  value,
  onChange,
  error,
  type = 'text',
  placeholder,
  optional,
  optionalLabel
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  error?: string;
  type?: string;
  placeholder?: string;
  optional?: boolean;
  optionalLabel?: string;
}) {
  return <div data-id="element-441" data-mp="20zc0patfippk">
      <div className="flex items-baseline justify-between mb-3" data-id="element-442" data-mp="20zkdl2pjxv0r">
        <label className="text-[10px] tracking-[0.3em] uppercase text-cream/50" data-id="element-443" data-mp="2fw2saxwv2x4m">
          {label}
        </label>
        {optional && <span className="text-[10px] tracking-[0.2em] uppercase text-cream/25" data-id="element-444" data-mp="2auvlb12jm1z0">
            {optionalLabel}
          </span>}
      </div>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="w-full bg-transparent border-b border-cream/20 focus:border-caramel outline-none py-3 text-cream placeholder:text-cream/25 transition-colors duration-500 font-serif text-lg" data-id="element-445" data-mp="3mbvm6l2yhp4n" />
      {error && <p className="text-caramel/80 text-[10px] tracking-[0.2em] uppercase mt-3" data-id="element-446" data-mp="3kw9ci1nbkj8z">
          {error}
        </p>}
    </div>;
}